import React from "react";
import Pagination from "@mui/material/Pagination";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function PaginationResults({ pagination, disabled, onChange, ...props }) {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("sm"));
  const size = isMobile ? "small" : "medium";

  const configuration = pagination.totalPages
    ? {
        disabled: disabled,
        count: pagination.totalPages,
        page: pagination.currentPage,
        onChange,
        size,
      }
    : { disabled: true, count: 3, page: 1, size };

  return <Pagination {...configuration} {...props} />;
}
